import request from '@/utils/request'

// 过磅审核列表
export function getWeighList(params) {
  return request.get('/wms/weigh/list', { params })
}

// 审核预览
export function getWeighAuditPreview(weighId) {
  return request.get(`/wms/weigh/audit_preview/${weighId}`)
}

// 审核提交（这里只做通过）
export function auditWeigh(weighId, data) {
  return request.put(`/wms/weigh/audit/${weighId}`, data)
}